import axios from "axios";
import store from "@/state/store";
import { CARTA_BASE_API_URL } from "@/config";
import router from "@/router";
import Vue from "vue";
export const axiosInstance = (() => {
  const options = {
    baseURL: CARTA_BASE_API_URL,
    timeout: 30000,
  };
  let requestHeaders = {
    Accept: "application/json, text/plain, */*",
    Appkey: "hazbulla",
  };
  const axiosClient = axios.create(options);

  axiosClient.interceptors.request.use(
    (requestConfig) => {
      const token = store.getters["auth/token"];
      store.dispatch("common/setLoading", true);
      if (token) {
        requestHeaders = {
          ...requestHeaders,
          Authorization: token,
        };
      }

      requestConfig.headers = {
        ...requestHeaders,
      };

      if (requestConfig.baseURL) {
        axiosClient.defaults.baseURL = requestConfig.baseURL;
      }

      if (!requestConfig.skipRouteParams && router.currentRoute.query.view) {
        requestConfig.params = {
          ...requestConfig.params,
          type:
            requestConfig?.params?.type ??
            (router.currentRoute.query.view
              ? router.currentRoute.query.view
              : "c"),
          org_id: requestConfig?.params?.org_id ?? router.currentRoute.query.o,
          project_id:
            requestConfig?.params?.project_id ?? router.currentRoute.query.p,
        };
      }

      return requestConfig;
    },
    (requestError) => {
      return Promise.reject(requestError);
    }
  );

  axiosClient.interceptors.response.use(
    (response) => {
      store.dispatch("common/setLoading", false);
      return response;
    },
    (error) => {
      store.dispatch("common/setLoading", false);

      if (!error.response) {
        Vue.notify({
          type: "error",
          title: "Something went wrong",
        });
        return Promise.reject();
      }

      const path = router.currentRoute.fullPath;

      const isOnSignupOrSignin =
        path.includes("login") ||
        path.includes("signin") ||
        path.includes("signup");

      if (isOnSignupOrSignin) {
        return Promise.reject(error);
      }

      if (error.response.status === 401 || error.response.status === 403) {
        Vue.notify({
          title: "Unauthorized",
          type: "error",
        });
      } else if (error.response.status === 500) {
        if (path.includes("/team")) return Promise.reject(error);
        Vue.notify({
          type: "error",
          title: "Something went wrong.",
        });
      } else {
        let errorData = error.response.data;
        if (Array.isArray(errorData)) {
          errorData = errorData[0];
        }
        Vue.notify({
          type: "error",
          title: errorData.message,
        });
      }
      return Promise.reject(error);
    }
  );

  return axiosClient;
})();

function makeRequest(meta) {
  const {
    url,
    method,
    params,
    headers,
    data,
    baseURL = CARTA_BASE_API_URL,
    skipRouteParams,
    ...rest
  } = meta;
  let requestHeaders = headers || {};

  const httpOptions = {
    method: method.toLowerCase(),
    url,
    params,
    headers: requestHeaders,
    data,
    baseURL,
    skipRouteParams,
    ...rest,
  };

  return axiosInstance.request(httpOptions);
}

export default makeRequest;
